import React from "react";
import { useNavigate } from "react-router-dom";
import {
  Sparkles,
  ArrowUpRight,
  MoveDown,
} from "lucide-react";
import "./CatalogPage.css";

import catpuresilk from "../assets/images/catpuresilk.png";
import cattussar from "../assets/images/cattussar.png";
import catsemitussar from "../assets/images/catsemitussar.png";
import catpurecotton from "../assets/images/catpurecotton.png";
import catfancy from "../assets/images/catfancy.png";
import catraw from "../assets/images/catraw.png";

const WHATSAPP_NUMBER = "916235523889";

const categories = [
  {
    id: "pure-silk",
    number: "01",
    title: "Pure Silk",
    subtitle: "THE TIMELESS EDIT",
    image: catpuresilk,
  },
  {
    id: "tussar-silk",
    number: "02",
    title: "Tussar Silk",
    subtitle: "NATURAL ELEGANCE",
    image: cattussar,
  },
  {
    id: "semi-tussar-silk",
    number: "03",
    title: "Semi Tussar Silk",
    subtitle: "GRACEFUL WEAVES",
    image: catsemitussar,
  },
  {
    id: "fancy-sarees",
    number: "04",
    title: "Fancy Sarees",
    subtitle: "MODERN CHARM",
    image: catfancy,
  },
  {
    id: "pure-cotton",
    number: "05",
    title: "Pure Cotton Sarees",
    subtitle: "EFFORTLESS COMFORT",
    image: catpurecotton,
  },
  {
    id: "art-silk",
    number: "06",
    title: "Art Silk Sarees",
    subtitle: "CONTEMPORARY ELEGANCE",
    image: catraw,
  },
];

const CatalogPage = () => {
  const navigate = useNavigate();

  const enquireNow = (category) => {
    const message = `Hi VEDHYAS, I'm interested in ${category.title}. Please share the available sarees, prices and details.`;

    const whatsappUrl = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
      message
    )}`;

    window.open(whatsappUrl, "_blank", "noopener,noreferrer");
  };

  return (
    <main className="vh-page">

      {/* =========================================
          HERO
      ========================================= */}

      <section className="vh-hero">

        <div className="vh-hero-glow vh-glow-1" />
        <div className="vh-hero-glow vh-glow-2" />

        <div className="vh-floating-dot vh-dot-1" />
        <div className="vh-floating-dot vh-dot-2" />
        <div className="vh-floating-dot vh-dot-3" />
        <div className="vh-floating-dot vh-dot-4" />

        <div className="vh-hero-content">

          <div className="vh-eyebrow">
            <span />
            <Sparkles />
            <b>THE VEDHYAS EDIT</b>
            <Sparkles />
            <span />
          </div>

          <h1>
            A Saree for
            <span> Every Story</span>
          </h1>

          <p>
            Discover carefully curated sarees where beautiful
            fabrics, graceful colours and timeless elegance meet.
          </p>

          <div className="vh-scroll">
            <span>Explore Collections</span>
            <MoveDown />
          </div>

        </div>

        <div className="vh-hero-line">
          <span>VEDHYAS</span>
          <i />
          <span>CURATED WITH ELEGANCE</span>
        </div>

      </section>


      {/* =========================================
          COLLECTION INTRO
      ========================================= */}

      <section className="vh-intro">

        <div className="vh-intro-left">

          <span className="vh-section-label">
            OUR COLLECTIONS
          </span>

          <h2>
            Find your
            <em> perfect weave.</em>
          </h2>

        </div>

        <p>
          From the richness of pure silk to the effortless
          beauty of cotton, explore collections created for
          different moods, moments and styles.
        </p>

      </section>


      {/* =========================================
          CATEGORY COLLECTION
      ========================================= */}

      <section className="vh-categories">

        {categories.map((category, index) => (

          <article
            key={category.id}
            className={`vh-category vh-category-${index + 1}`}
          >

            <div className="vh-category-image">

              <img
                src={category.image}
                alt={category.title}
                loading="lazy"
              />

              {/* Dark cinematic overlay */}
              <div className="vh-image-overlay" />

              {/* Gold light sweep */}
              <div className="vh-light-sweep" />

              {/* Golden center glow */}
              <div className="vh-image-glow" />

              {/* Fine border */}
              <div className="vh-inner-border" />


              {/* Number */}
              <span className="vh-number">
                {category.number}
              </span>


              {/* Sparkles */}
              <span className="vh-card-star vh-star-1">
                ✦
              </span>

              <span className="vh-card-star vh-star-2">
                ✧
              </span>


              {/* Category content */}
              <div className="vh-category-content">

                <span className="vh-category-subtitle">
                  {category.subtitle}
                </span>

                <h3>
                  {category.title}
                </h3>


                {/* ENQUIRE BUTTON */}
                <button
                  type="button"
                  className="vh-enquire-btn"
                  onClick={(e) => {
                    e.stopPropagation();
                    enquireNow(category);
                  }}
                >
                  <span>
                    Enquire Now
                  </span>

                  <div className="vh-enquire-arrow">
                    <ArrowUpRight />
                  </div>
                </button>

              </div>

            </div>

          </article>

        ))}

      </section>


      {/* =========================================
          FINAL BRAND STATEMENT
      ========================================= */}

      <section className="vh-statement">

        <div className="vh-statement-glow" />

        <Sparkles className="vh-statement-sparkle" />

        <span className="vh-statement-label">
          VEDHYAS
        </span>

        <h2>
          Woven for the moments
          <span> worth remembering.</span>
        </h2>

        <p>
          Timeless fabrics. Beautiful colours.
          Sarees chosen with intention.
        </p>

        <button
          type="button"
          onClick={() => navigate("/catalog")}
        >
          <span>View All Collections</span>
          <ArrowUpRight />
        </button>

      </section>

    </main>
  );
};

export default CatalogPage;